import { noop } from 'lodash';

export const promptReview = noop;
